exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-transition-card-3XN9Z{width:64px;height:40px;display:flex;flex-flow:column wrap;align-items:center;justify-content:center;background:#fff;background-size:cover;border-radius:4px;border:1px solid rgba(0,0,0,.08);box-sizing:border-box}.index-transition-card-icon-2EelQ{display:block;width:20px;height:20px}.index-transition-card-text-1vsm3{font-family:PingFang SC;font-size:11px;font-weight:500;line-height:11px;text-align:center;color:rgba(0,0,0,.64);cursor:default}", ""]);

// Exports
exports.locals = {
	"transition-card": "index-transition-card-3XN9Z",
	"transition-card-icon": "index-transition-card-icon-2EelQ",
	"transition-card-text": "index-transition-card-text-1vsm3"
};